<template>
  <div class="money-table">
    <div class="rank-box">
      <p class="mb10">专业职级：<span style="color:#b8b8b8">（点击职级可直接查看薪酬）</span></p>
      <div class="ranktag-box">
        <el-button
          v-for="(item, index) in professionalRank"
          :id="`professional${poperId}${index}`"
          :key="`professional${poperId}${index}`"
          class="mr10 mb10"
          size="mini"
          @click="showPoper(item, `professional${poperId}${index}`)"
        >
          {{ item.专业职级 }}
        </el-button>
      </div>
      <p class="mb10">管理职级：<span style="color:#b8b8b8">（点击职级可直接查看薪酬）</span></p>
      <div class="ranktag-box">
        <el-button
          v-for="(item, index) in ManagerialRank"
          :id="`managerial${poperId}${index}`"
          :key="`managerial${poperId}${index}`"
          class="mr10 mb10"
          size="mini"
          @click="showPoper(item, `managerial${poperId}${index}`)"
        >
          {{ item.管理职级 }}
        </el-button>
      </div>
    </div>
    <div class="text-box" v-if="!hideContent">
      <div v-for="item in textFields" :key="item" class="mb10">
        <p v-if="table.content && table.content[item]" class="mb10">{{ item }}</p>
        <pre v-if="table.content && table.content[item]" style="white-space: pre-wrap;">{{
          (table.content && table.content[item]) || ''
        }}</pre>
      </div>
    </div>

    <!-- poper -->
    <Popper
      :id="`newMoneyTable${poperId}`"
      :visible.sync="popperVisible"
      style="z-index: 31;"
      :target-id="popperTarget"
      container="projectTableWrapper"
    >
      <div class="money-table-popper">
        <p class="bolder">{{ activeRank.专业职级 || activeRank.管理职级 }}职级</p>
        <p>
          年限：<span class="bolder ml10">{{ activeRank.年限 }}</span>
        </p>
        <p>
          固薪：<span class="bolder ml10">{{ activeRank.固薪 }}</span>
        </p>
        <p>
          奖金：<span class="bolder ml10">{{ activeRank.奖金 }}</span>
        </p>
        <p>
          全薪：<span class="bolder ml10">{{ activeRank.全薪 }}</span>
        </p>
      </div>
    </Popper>
  </div>
</template>
<script>
// import { moneyTable, moneyContent } from '../../statistics/variant/table'
// import * as fixedvariant from '../../statistics/variant/fixedvariant'
import * as fixedvariant from '../../statistics/variant/fixedvariant'
import Popper from '../../../project/src/components/Popper'

const shortid = require('shortid')

const prefessionalSortMap = {}
const managerialSortMap = {}
const levels = ['MD', 'ED', 'D', 'AD', 'SVP', 'VP', 'SA', 'Asso', 'AN']
const options = [{ label: 'ManagingPartner', value: 'ManagingPartner' }, { label: 'Partner', value: 'Partner' }]
levels.forEach(v => {
  const obj = { label: v, value: v, children: [{ label: v, value: v }] }
  for (let i = 1; i < 5; i++) {
    obj.children.push({ label: `${v}${i}`, value: `${v}${i}` })
  }
  options.push(obj)
})

let sortNum = 1
for (let i = options.length; i > 0; i--) {
  const option = options[i - 1]
  if (option.children) {
    // eslint-disable-next-line no-loop-func
    option.children.forEach(v => {
      prefessionalSortMap[v.value] = sortNum++
    })
  } else {
    prefessionalSortMap[option.value] = sortNum++
  }
}
fixedvariant.管理职级表头.forEach((val, index) => {
  managerialSortMap[val] = index + 1
})

export default {
  components: { Popper },
  props: {
    table: { type: Object, default: () => ({}) },
    hideContent: { type: Boolean, default: false },
  },
  data() {
    return {
      professionalRank: [],
      ManagerialRank: [],
      textFields: ['奖金机制', '奖金发放时间', '递延机制', '考核', '备注'],
      activeRank: {},
      popperVisible: false,
      popperTarget: null,
      poperId: '',
    }
  },
  watch: {
    table: {
      handler(newVal, oldVal) {
        this.init()
      },
      immediate: true,
      deep: true,
    },
  },
  async mounted() {
    // await this.setOption()
    // await this.getdata()
    this.poperId = shortid.generate()
  },
  methods: {
    init() {
      const { table } = this
      const professionalRank = ((table && table.table) || []).filter(v => v.专业职级)
      const ManagerialRank = ((table && table.table) || []).filter(v => v.管理职级)
      professionalRank.sort((a, b) => (prefessionalSortMap[a.专业职级] || 0) - (prefessionalSortMap[b.专业职级] || 0))
      ManagerialRank.sort((a, b) => (managerialSortMap[a.管理职级] || 100) - (managerialSortMap[b.管理职级] || 100))
      this.professionalRank = professionalRank
      this.ManagerialRank = ManagerialRank
    },
    showPoper(data, targetId) {
      this.activeRank = data
      this.popperVisible = true
      this.popperTarget = targetId
    },
  },
}
</script>
<style scoped>
.ranktag-box {
  display: flex;
  flex-wrap: wrap;
}
pre {
  margin: 0;
  text-indent: 0;
  padding: 10px 15px;
  background-color: #f7f9fc;
  width: 100%;
  box-sizing: border-box;
  font-size: 14px;
  line-height: 1.5;
  color: #262626;
  position: relative;
}
.money-table-popper {
  padding: 10px 20px;
  border: 1px solid #eaeefb;
  border-radius: 4px;
  background-color: #fff;
  box-shadow: 0 0 8px 0 rgba(232, 237, 250, 0.6), 0 2px 4px 0 rgba(232, 237, 250, 0.5);
}
.bolder {
  font-weight: 700;
}
</style>
